import { AsyncTaskStatus } from 'src/utilities/useAsyncTask';

export enum ZipFileStatus {
  IDLE = 'IDLE',
  GENERATE = 'GENERATE',
  FETCHING = 'FETCHING',
  DOWNLOAD = 'DOWNLOAD',
  COMPLETE = 'COMPLETE',
  DOWNLOAD_SUCCESSFULLY = 'DOWNLOAD_SUCCESSFULLY',
  DOWNLOAD_FAILED = 'DOWNLOAD_FAILED',
  TOO_MANY = 'TOO_MANY',
}

export enum ZipGenerationApiStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND',
  IDLE = 'IDLE',
}

export interface ZipFileFilters {
  dateFrom: string;
  dateTo: string;
  query?: string;
}

export interface ZipDetailsResponse {
  max_pdf_files_download_allowed: number;
  details: {
    status: ZipGenerationApiStatus;
    date_from?: string;
    date_to?: string;
    query?: string;
  };
}

export interface OrderReceiptsZipDetailsData {
  status: ZipFileStatus;
  filters: ZipFileFilters;
  maximumReceiptsAllowed: number;
}

export const DATE_FORMAT = 'MMM d';

export const apiPdfStatusToClientPdfStatusMap = new Map<
  ZipGenerationApiStatus,
  ZipFileStatus
>([
  [ZipGenerationApiStatus.IN_PROGRESS, ZipFileStatus.FETCHING],
  [ZipGenerationApiStatus.COMPLETE, ZipFileStatus.DOWNLOAD],
  [ZipGenerationApiStatus.ERROR, ZipFileStatus.DOWNLOAD_FAILED],
  [ZipGenerationApiStatus.NOT_FOUND, ZipFileStatus.GENERATE],
  [ZipGenerationApiStatus.IDLE, ZipFileStatus.IDLE],
]);

export const asyncTaskToPDFGenerationStatusMap = new Map<
  AsyncTaskStatus,
  ZipFileStatus
>([
  [AsyncTaskStatus.IN_PROGRESS, ZipFileStatus.FETCHING],
  [AsyncTaskStatus.COMPLETE, ZipFileStatus.COMPLETE],
  [AsyncTaskStatus.ERROR, ZipFileStatus.DOWNLOAD_FAILED],
  [AsyncTaskStatus.IDLE, ZipFileStatus.GENERATE],
]);

export const transformOrderReceiptsZipDetailsAPIToUIModel = (
  response: ZipDetailsResponse
): OrderReceiptsZipDetailsData => {
  return {
    maximumReceiptsAllowed: response.max_pdf_files_download_allowed,
    status: apiPdfStatusToClientPdfStatusMap.get(response.details.status),
    filters: {
      dateFrom: response.details.date_from,
      dateTo: response.details.date_to,
      query: response.details.query,
    },
  };
};
